import { AxiosResponse } from 'axios';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { Configuration, PmsApi, CompanyStaffDto } from '@inosio/payments-sdk';
import { selectCurrentUser } from '../../../shared/sagas/auth/authSlice';
import { getPmAssociatedStaff, setPmAssociatedStaff } from './pmConfigSettingsSlice';
import {IpaUserExtended} from '../../../shared/sagas/auth/authSlice';

const { REACT_APP_IPA_BASE_PATH } = process.env;
const apiConfig = new Configuration({ basePath: REACT_APP_IPA_BASE_PATH });

export function requestGetPmAssociatedStaff(access_token: string, pmUuid: string) {
  apiConfig.accessToken = access_token;
  const pgApi = new PmsApi(apiConfig);
  return pgApi.getAssociatedCompanyStaff(pmUuid);
}

export function* handleGetPmAssociatedStaff(action: {type: typeof getPmAssociatedStaff; }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<CompanyStaffDto[]> = yield call(requestGetPmAssociatedStaff, currentUser.accessToken, currentUser.currentProfile.uuid);

    const { data } = response;

    yield put(setPmAssociatedStaff(data));
  } catch (error: any) {
    // yield put(setConfigSettingsError({ message: error?.response?.data?.message }));//TODO uncomment this guy
  }
}

export function* pmConfigSettingsSaga() {
  yield takeLatest(getPmAssociatedStaff.type, handleGetPmAssociatedStaff);
}
